(function(){
'use strict';
if(window.CircleAHatTracking)return;
const root='https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@0.10.32';
const model='https://storage.googleapis.com/mediapipe-models/face_landmarker/face_landmarker/float16/1/face_landmarker.task';
let runtime;
const clamp=(x,a,b)=>Math.max(a,Math.min(b,x));
const norm=v=>{const n=Math.hypot(...v);return n>1e-6?v.map(x=>x/n):null};
const cross=(a,b)=>[a[1]*b[2]-a[2]*b[1],a[2]*b[0]-a[0]*b[2],a[0]*b[1]-a[1]*b[0]];
const median=a=>{const b=a.slice().sort((x,y)=>x-y);return b[Math.floor(b.length/2)]};
const faceOval=[10,338,297,332,284,251,389,356,454,323,361,288,397,365,379,378,400,377,152,148,176,149,150,136,172,58,132,93,234,127,162,21,54,103,67,109];
function matrixRotation(matrix){
 const m=matrix?.data;if(!m||m.length!==16||!Array.from(m).every(Number.isFinite))return null;
 const x=norm([m[0],m[1],m[2]]),up=norm([m[4],m[5],m[6]]);
 const z=x&&up&&norm(cross(x,up));
 return z&&z[2]>.05?[...x,...norm(cross(z,x)),...z]:null;
}
function pose(landmarks,width=600,height=750,matrix){
 if(!landmarks||landmarks.length<455)return null;
 const point=i=>({x:landmarks[i].x*width,y:landmarks[i].y*height,z:landmarks[i].z*width});
 const top=point(10),brow=point(9),chin=point(152);
 const eyes=[point(33),point(263)].sort((x,y)=>x.x-y.x),temples=[point(127),point(356)].sort((x,y)=>x.x-y.x);
 const distance=(a,b)=>Math.hypot(a.x-b.x,a.y-b.y,a.z-b.z),faceWidth=distance(...temples),eyeWidth=distance(...eyes);
 if(!Number.isFinite(faceWidth)||faceWidth<width*.07||faceWidth>width*1.5||eyeWidth<width*.035)return null;
 const x=norm([eyes[1].x-eyes[0].x,eyes[0].y-eyes[1].y,eyes[0].z-eyes[1].z]);
 const up=norm([top.x-chin.x,chin.y-top.y,chin.z-top.z]);
 if(!x||!up)return null;
 let z=norm(cross(x,up));if(!z)return null;if(z[2]<0)z=z.map(v=>-v);
 const y=norm(cross(z,x)),rotation=matrixRotation(matrix)||[...x,...y,...z];
 if(!rotation.every(Number.isFinite))return null;
 return {x:top.x*.62+brow.x*.38,y:top.y*.62+brow.y*.38,width:faceWidth*1.04,eyeWidth,chinY:chin.y,faceHeight:distance(top,chin),angle:Math.atan2(rotation[3],rotation[4]),yaw:Math.atan2(-rotation[2],rotation[8]),pitch:Math.asin(clamp(rotation[5],-1,1)),rotation,outline:faceOval.map(i=>({x:landmarks[i].x*width,y:landmarks[i].y*height}))};
}
function smoothRotation(a,b,t){
 const r=a.map((v,i)=>v+(b[i]-v)*t),x=norm(r.slice(0,3)),z=x&&norm(cross(x,r.slice(3,6)));
 return x&&z?[...x,...norm(cross(z,x)),...z]:b.slice();
}
function filter(){
 let value=null,last=0;
 return {reset(){value=null;last=0},update(next,time){
  if(!next)return null;
  if(!value||time-last>450){value={...next,rotation:next.rotation.slice()};last=time;return value}
  const dt=clamp((time-last)/1000,.001,.15),speed=Math.hypot(next.x-value.x,next.y-value.y)/Math.max(next.width,1)/dt;
  const gain=1-Math.exp(-dt*(7+clamp(speed*14,0,35))),scaleGain=1-Math.exp(-dt*12),turn=Math.abs(next.yaw-value.yaw)/dt;
  const result={...next};for(const k of ['x','y'])result[k]=value[k]+(next[k]-value[k])*gain;
  result.width=value.width+(next.width-value.width)*scaleGain;
  if(next.outline&&value.outline?.length===next.outline.length)result.outline=next.outline.map((p,i)=>({x:value.outline[i].x+(p.x-value.outline[i].x)*gain,y:value.outline[i].y+(p.y-value.outline[i].y)*gain}));
  result.rotation=smoothRotation(value.rotation,next.rotation,1-Math.exp(-dt*(10+clamp(turn*8,0,25))));
  result.yaw=Math.atan2(-result.rotation[2],result.rotation[8]);result.pitch=Math.asin(clamp(result.rotation[5],-1,1));result.angle=Math.atan2(result.rotation[3],result.rotation[4]);
  value=result;last=time;return value;
 }};
}
function calibrator(){
 let samples=[],last=0;
 return {reset(){samples=[];last=0},step(p,time,view){
  let reason=null;
  if(!p)reason='fit_find_face';
  else if(Math.abs(p.yaw)>.28||Math.abs(p.pitch)>.45||Math.abs(p.angle)>.23)reason='fit_face_front';
  else if(p.width/view.width<.18)reason='fit_move_closer';
  else if(p.width/view.width>.43)reason='fit_move_back';
  else if(p.x<view.width*.30||p.x>view.width*.70)reason='fit_center';
  else if(p.y<Math.max(view.height*.20,p.width*(view.crownRatio||.8)+view.height*.14))reason='fit_headroom';
  else if(p.chinY>view.height*.84)reason='fit_raise_phone';
  else if(view.luma!=null&&view.luma<36)reason='fit_more_light';
  else if(view.luma!=null&&view.luma>242)reason='fit_less_light';
  if(reason){samples=[];last=time;return {ready:false,progress:0,reason}}
  const previous=samples[samples.length-1];
  if(previous&&(time-last>1500||Math.hypot(p.x-previous.p.x,p.y-previous.p.y)>p.width*.06||Math.abs(p.width-previous.p.width)>p.width*.055))samples=[];
  samples.push({p,time});last=time;if(samples.length>40)samples.shift();
  const elapsed=time-samples[0].time,progress=Math.min(1,elapsed/900,samples.length/8);
  if(progress<1)return {ready:false,progress,reason:'fit_hold_still'};
  return {ready:true,progress:1,reason:'fit_complete',calibration:{eyeScale:median(samples.map(s=>s.p.width/s.p.eyeWidth))}};
 }};
}
function stabilize(p,calibration){
 if(!p||!calibration)return p;
 const blend=.20+clamp(Math.abs(p.yaw)/1.1,0,1)*.55;
 return {...p,width:p.width*(1-blend)+p.eyeWidth*calibration.eyeScale*blend};
}
function cameraFocal(sourceWidth,sourceHeight,width,height){
 const cover=Math.max(width/sourceWidth,height/sourceHeight);
 return Number.isFinite(cover)&&cover>0?.9*Math.max(sourceWidth,sourceHeight)*cover:.9*Math.max(width,height);
}
function placement(p,opening,trim={},view){
 const anchorScale=p.width/(2*opening.a)*(trim.scale||1),head=p.rotation,seat=(trim.seat||0)*p.width;
 const tilt=view?.tilt??0,c=Math.cos(tilt),s=Math.sin(tilt);
 const r=[...head.slice(0,3),...head.slice(3,6).map((v,i)=>v*c+head[i+6]*s),...head.slice(6,9).map((v,i)=>v*c-head[i+3]*s)];
 const ax=p.x-head[3]*seat,ay=p.y+head[4]*seat;
 const front=[r[6]*opening.b,r[7]*opening.b,r[8]*opening.b];
 if(!(view?.focal>0))return {x:ax-front[0]*anchorScale,y:ay+front[1]*anchorScale,scale:anchorScale,rotation:r};
 const depth=view.focal/anchorScale,centerDepth=depth+front[2],scale=view.focal/centerDepth;
 const cx=view.width/2,cy=view.height/2;
 return {x:cx+((ax-cx)/anchorScale-front[0])*scale,y:cy+((ay-cy)/anchorScale+front[1])*scale,scale,perspective:1/centerDepth,rotation:r};
}
async function mainDetector(){
 if(!runtime)runtime=import(root+'/vision_bundle.mjs').then(async m=>({m,files:await m.FilesetResolver.forVisionTasks(root+'/wasm')})).catch(e=>{runtime=null;throw e});
 const {m,files}=await runtime;
 const options={baseOptions:{modelAssetPath:model,delegate:'GPU'},runningMode:'VIDEO',numFaces:1,minFaceDetectionConfidence:.6,minFacePresenceConfidence:.6,minTrackingConfidence:.6,outputFaceBlendshapes:false,outputFacialTransformationMatrixes:true};
 let detector;try{detector=await m.FaceLandmarker.createFromOptions(files,options)}catch(e){options.baseOptions.delegate='CPU';detector=await m.FaceLandmarker.createFromOptions(files,options)}
 return {mode:'main',async detect(source,time){const result=detector.detectForVideo(source,time);return pose(result.faceLandmarks?.[0],source.width,source.height,result.facialTransformationMatrixes?.[0])},close(){detector.close()}};
}
async function workerDetector(){
 const code=`let detector;self.onmessage=async e=>{const d=e.data;try{if(d.type==='init'){const m=await import(d.root+'/vision_bundle.mjs'),files=await m.FilesetResolver.forVisionTasks(d.root+'/wasm');const options={baseOptions:{modelAssetPath:d.model,delegate:'GPU'},runningMode:'VIDEO',numFaces:1,minFaceDetectionConfidence:.6,minFacePresenceConfidence:.6,minTrackingConfidence:.6,outputFaceBlendshapes:false,outputFacialTransformationMatrixes:true};try{detector=await m.FaceLandmarker.createFromOptions(files,options)}catch(e){options.baseOptions.delegate='CPU';detector=await m.FaceLandmarker.createFromOptions(files,options)}self.postMessage({type:'ready'})}else if(d.type==='frame'){let result;try{result=detector.detectForVideo(d.bitmap,d.time)}finally{d.bitmap.close()}self.postMessage({type:'result',id:d.id,landmarks:result.faceLandmarks?.[0],matrix:result.facialTransformationMatrixes?.[0]})}}catch(error){self.postMessage({type:'error',id:d.id,message:String(error.message||error)})}};`;
 const url=URL.createObjectURL(new Blob([code],{type:'text/javascript'}));
 let worker;try{worker=new Worker(url,{type:'module'})}finally{URL.revokeObjectURL(url)}
 let pending=null,disposed=false,serial=0,initTimer;
 const ready=new Promise((resolve,reject)=>{
  initTimer=setTimeout(()=>reject(Error('Tracking startup timed out')),12000);
  worker.onmessage=e=>{const d=e.data;if(d.type==='ready'){clearTimeout(initTimer);resolve()}
   else if(d.type==='result'&&pending?.id===d.id){clearTimeout(pending.timer);pending.resolve({landmarks:d.landmarks,matrix:d.matrix});pending=null}
   else if(d.type==='error'){if(pending){clearTimeout(pending.timer);pending.reject(Error(d.message));pending=null}else{clearTimeout(initTimer);reject(Error(d.message))}}};
  worker.onerror=e=>{clearTimeout(initTimer);if(pending){clearTimeout(pending.timer);pending.reject(Error(e.message||'Tracking worker stopped'));pending=null}else reject(Error(e.message||'Tracking worker unavailable'))};
  worker.postMessage({type:'init',root,model});
 });
 try{await ready}catch(e){worker.terminate();throw e}
 return {mode:'worker',async detect(source,time){
  if(disposed)throw Error('Tracking closed');if(pending)return null;
  const bitmap=await createImageBitmap(source);if(disposed){bitmap.close();throw Error('Tracking closed')}
  const id=++serial,result=await new Promise((resolve,reject)=>{
   pending={id,resolve,reject,timer:setTimeout(()=>{pending=null;reject(Error('Tracking frame timed out'))},3000)};
   try{worker.postMessage({type:'frame',bitmap,id,time},[bitmap])}catch(e){bitmap.close();clearTimeout(pending.timer);pending=null;reject(e)}
  });
  return pose(result.landmarks,source.width,source.height,result.matrix);
 },close(){disposed=true;clearTimeout(initTimer);if(pending){clearTimeout(pending.timer);pending.reject(Error('Tracking closed'));pending=null}worker.terminate()}};
}
async function create(){
 if(typeof Worker==='function'&&typeof createImageBitmap==='function'&&typeof OffscreenCanvas==='function'){
  try{return await workerDetector()}catch(e){}
 }
 return mainDetector();
}
window.CircleAHatTracking={create,pose,filter,calibrator,stabilize,placement,cameraFocal,matrixRotation};
})();
